namespace RioERP.Masters {
    export namespace BrandAmbassadorSettingsService {
        export const baseUrl = 'Masters/BrandAmbassadorSettings';

        export declare function Create(request: Serenity.SaveRequest<BrandAmbassadorSettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<BrandAmbassadorSettingsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<BrandAmbassadorSettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<BrandAmbassadorSettingsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/BrandAmbassadorSettings/Create",
            Update = "Masters/BrandAmbassadorSettings/Update",
            Delete = "Masters/BrandAmbassadorSettings/Delete",
            Retrieve = "Masters/BrandAmbassadorSettings/Retrieve",
            List = "Masters/BrandAmbassadorSettings/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>BrandAmbassadorSettingsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
